const TourTypes = {
    SET_TOUR_RUN: 'SET_TOUR_RUN',
    SET_TOUR_INDEX: 'SET_TOUR_INDEX'
};
export default TourTypes;